'use client'

import type { ReactNode } from 'react'
import { RowSurfaceProvider } from '@/deskUiSkeletons/rowTemplates/RowSurfaceContext'
import type { RowSkin, RowSurface } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defaultFolderRowSkin } from '@/msgComponents/skins/folderRowSkin'
import { SubRow } from '@/deskUiSkeletons/subs/SubRow'
import { showQuickReplyModal } from '@/deskUiSkeletons/Shared/QuickReplyModal'
import { rowVariantRegistry } from './RowTemplateRegistry'
import { nestedTemplateVariant } from './RowTemplateConfig'
import { defaultBlockedPreviewSkin } from '@/msgComponents/skins/blockedPreviewSkin'

const pooRowSkin: RowSkin = {
  row: {
    base: 'clear-both border-0 border-b border-[#e6e6e6] bg-white text-black',
    hidden: 'hidden',
    checked: 'opacity-60',
    foreign: 'opacity-[0.92]',
    foreignFrom: 'block pt-0.5 text-[12px] text-[#888] [&_a]:text-[#07c] [&_a]:no-underline [&_a:hover]:underline',
  },
  blockedNotice: { ...defaultBlockedPreviewSkin },
  icon: {
    base: 'inline-block h-[13px] w-[13px] box-border cursor-pointer border align-middle',
    checkOn: 'border-[#1d578e] bg-[#3472a9]',
    checkOff: 'border-[#a7a7a7] bg-[#f5f5f5]',
    favOn: 'border-[#1d578e] bg-[#3472a9]',
    favOff: 'border-[#a7a7a7] bg-[#f5f5f5]',
    qrOn: 'border-[#1d578e] bg-[#3472a9]',
    qrOff: 'border-[#a7a7a7] bg-[#f5f5f5]',
  },
  titleLink: 'inline-block font-bold text-[#07c] no-underline',
  timeWrap: 'inline whitespace-nowrap text-[13px] text-[#888]',
  timeText: 'inline whitespace-nowrap text-[13px] text-[#888]',
  text: 'clear-both block min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-[13px] text-[#888]',
  metaLink: 'mr-2 inline-block cursor-pointer text-[13px] text-[#07c]',
  metaMore: 'mr-2 inline-block cursor-pointer text-[13px] text-[#07c]',
  meta: 'text-[13px] text-[#07c]',
  feed: 'clear-both block list-none m-0 p-0',
  folder: { ...defaultFolderRowSkin },
}

const pooRowSurface: RowSurface = {
  SubRow,
  showQuickReplyModal,
  variants: rowVariantRegistry,
  config: { nestedTemplateVariant },
  skin: pooRowSkin,
}

export function PooRowSurfaceProvider({ children }: { children: ReactNode }) {
  return <RowSurfaceProvider value={pooRowSurface}>{children}</RowSurfaceProvider>
}
